<template>
	<fragment v-if="lecture">
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container">
			<!-- side menus -->
			<common-side-menu :menus="side_menus" :btnList="side_buttons"></common-side-menu>
			<!-- //end .side-nav -->
			<section ref="container" class="container-fiuld class-making-box clearfix" v-if="article">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						{{side_menus.length ? side_menus.find(e=>e.selected).name : ''}}
					</div>
				</div>
				<div class="white-box m-t-10 clearfix">
					<p class="f-18 m-b-15 m-t-10 text-bold text-blue">{{article.title}}</p>
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<b>분류 :</b> {{article.articleCategoryNm}}
						</span>
						<span class="input-group-addon w100 text-left">
							<b>작성자 :</b> {{article.mberId}}
						</span>
						<span class="input-group-addon w160 text-left">
							<b>작성일 :</b> {{article.regDate}}
						</span>
						<span class="input-group-addon w60 text-left">
							<b>조회 :</b> {{ article.lookupCount }}
						</span>
					</div>
					<div class="on-border round p-15 m-t-5 m-b-10" v-html="article.content"></div>
					<ul class="m-b-10" v-if="article.articleFileMappingList.length > 0">
						<li v-for="file in article.articleFileMappingList" :key="`article-file-${hash(file)}`">
							<a class="down-btn" :href="'/download/'+file.atchFileId" target="_blank">{{file.file.orignlFileNm}}</a>
						</li>
					</ul>
				</div>
				<div class="white-box m-t-10 clearfix">
					<textarea class="full-width" cols="30" rows="2" v-model="newComment"></textarea>
					<button class="btn-sm round pull-right" @click="postComment">댓글달기</button>
				</div>
				<div class="white-box m-t-10 clearfix">
					<div class="comment" v-for="comment in article.commentList" :key="`comment-${hash(comment)}`">
						<p class="m-b-0 clearfix">
							{{comment.mberId}} ｜ {{comment.regDate}}
							<span class="pull-right" v-if="!modifyingComment || modifyingComment.commentId!=comment.commentId">
								<a class="modify" @click="modifyComment(comment)"></a>
								<a class="del" @click="deleteComment(comment)"></a>
							</span>
							<span class="pull-right" v-if="modifyingComment && modifyingComment.commentId==comment.commentId">
								<button class="btn-sm round pull-right" @click="modifyCommentConfirm">수정완료</button>
								<button class="btn-sm round pull-right" @click="modifyCommentCancel">취소</button>
							</span>
						</p>
						<div v-if="!modifyingComment || modifyingComment.commentId!=comment.commentId" class="bg-lightgray p-15" style="line-height: 1.4;" v-html="comment.content ? comment.content.replace(/\n/g, '<br>') : ''"></div>
						<textarea v-if="modifyingComment && modifyingComment.commentId==comment.commentId" class="full-width" cols="30" rows="2" v-model="modifyingComment.content"></textarea>
					</div>
				</div>
				<button class="btn btn-darkgray round m-t-30 m-b-30 pull-left"
					type="button" @click="$router.push('/board/' + side_menus.find(e=>e.selected).board.boardId)">목록</button>
				<button class="btn btn-blue round m-t-30 m-b-30 m-r-5 pull-right" type="button"
				@click="$router.push(`/classroom/${$route.params.lecId}/board/${$route.params.boardId}/write/${$route.params.articleId}`)">답글쓰기</button>
				<button class="btn btn-blue round m-t-30 m-b-30 m-r-5 pull-right" type="button"
				@click="$router.push(`/classroom/${$route.params.lecId}/board/${$route.params.boardId}/detail/${$route.params.articleId}/modify`)">수정</button>
				<button class="btn btn-red round m-t-30 m-b-30 m-r-5 pull-right" type="button" @click="deleteArticle">삭제</button>
			</section>
		</section>
		<common-footer></common-footer>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'

import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'

import Axios from 'axios'
import server from '../statics/server.js'


export default {
	mixins: [
		fnAdjustHeight,
		fnGetLec
	],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		CommonSideMenu,
		ModalConfirm,
		ModalAlert,
	},
	mounted: async function() {
		const { lecId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.side_menus = await this.getBoardSideMenus(lecId);
		this.getArtcle();
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			lecture: null,
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:false},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:true},
			],
			side_menus: [],
			side_buttons : [],
			buttons : [],
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},
			article: null,
			newComment: "",
			modifyingComment: null
		}
	},


	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		getArtcle: async function() {
			const { articleId } = this.$route.params;

			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.ARTICLE}/${articleId}`);

				this.article = data.return ? data.return : {};
			} catch(e) { e }
		},
		postComment: async function() {
			try {
				await Axios.put(`${server.addr()}${server.api.COMMENT}`, [{
					articleId: this.article.articleId,
					content: this.newComment
				}]);
				this.newComment = "";
				this.getArtcle();
			} catch(e) { e }
		},
		modifyComment: function(comment) {
			this.modifyingComment = JSON.parse(JSON.stringify(comment));
		},
		modifyCommentCancel: function() {
			this.modifyingComment = null;
		},
		modifyCommentConfirm: function() {
			Axios.patch(server.addr()+server.api.COMMENT+"/"+this.modifyingComment.commentId, this.modifyingComment).then( () => {
				this.modifyingComment = null;
				this.getArtcle();
			})
		},
		deleteComment: function(comment) {
			this.modals.ModalConfirm.msg = "댓글을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				Axios.delete(server.addr()+server.api.COMMENT+"/"+comment.commentId).then( () => {
					this.modals.ModalConfirm.show = false;
					this.getArtcle();
				})
			}
			this.modals.ModalConfirm.show = true;
		},
		deleteArticle: function() {
			this.modals.ModalConfirm.msg = "게시물을 정말 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "삭제";
			this.modals.ModalConfirm.btnYes.fn = () => {
				Axios.delete(server.addr()+server.api.ARTICLE+"/"+this.$route.params.articleId).then( () => {
					this.modals.ModalConfirm.show = false;
					this.$router.push("/classroom/"+this.$route.params.lecId+"/board/"+this.$route.params.boardId);
				})
			}
			this.modals.ModalConfirm.show = true;
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}

	.recycle {
		fill: #fff;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .recycle {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>
